import { AudioSelector } from '@optools/components/media/audio-selector';
import { MediaElementContext } from '@optools/components/media/MediaElementProvider/media-element-provider';
import { Label } from '@optools/components/ui/label';
import { Switch } from '@optools/components/ui/switch';
import { useContext } from 'react';

export interface PlaybackVerificationMediaControlsProps {
  daiEnabled: boolean;
  daiSupported: boolean;
  setDaiEnabled: (on: boolean) => void;
}

export function PlaybackVerificationMediaControls({
  daiEnabled,
  daiSupported,
  setDaiEnabled,
}: PlaybackVerificationMediaControlsProps) {
  const { mediaApi, mediaState } = useContext(MediaElementContext);

  return (
    <div className="flex min-h-15 items-center justify-between">
      {daiSupported && (
        <div className="flex items-center justify-center gap-2">
          <Switch
            aria-label="enable-google-dai"
            checked={daiEnabled}
            id="enable-google-dai"
            onCheckedChange={setDaiEnabled}
          />
          <Label className="cursor-pointer" htmlFor="enable-google-dai">
            DAI
          </Label>
        </div>
      )}
      {mediaState.audioTracks?.length > 0 && (
        <div className="ml-auto flex animate-fade-in flex-col items-center gap-1">
          <p className="text-xs font-medium">Current Audio Track:</p>
          <AudioSelector
            audioTracks={mediaState.audioTracks}
            selectedTrackIndex={mediaState.audioTrackIndex}
            onTrackSelected={(trackIndex) => mediaApi?.switchAudioTrack?.(trackIndex)}
          />
        </div>
      )}
    </div>
  );
}
